@if (eventTypes != null && eventTypes.length > 0) {
  <div class="grid-container">
    <section>
      @if (timeline.length) {
        <div class="grid-x">
          @for (item of timeline; track item; let isLast = $last) {
            <div class="history">
              <div class="cell small-8 bold event">Application {{translateEventType(item?.eventTypeId)}}</div>
              <div class="cell small-4 event margin-top">{{item?.eventDate | date: 'short'}}</div>
              <div class="cell small-12 margin-top">User: {{item?.userName}} | Organization: {{item?.organizationName}}</div>
              @if (!isLast) {
                <div class="cell small-12">
                  <hr>
                  </div>
                }
              </div>
            }
          </div>
        } @else {
          <p>There are currently no recorded events.</p>
        }
      </section>
    </div>
  } @else {
    <p>Timeline loading, please wait.</p>
  }



